import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { RowMenuItem, RowMenuOptions } from './types';

@Component({
  selector: 'row-menu',
  templateUrl: './row-menu.component.html',
  styleUrls: ['./row-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowMenuComponent implements OnChanges {
  @Input() options?: RowMenuOptions;
  @Output() copying = new EventEmitter<void>();
  @Output() editing = new EventEmitter<void>();
  @Output() deleting = new EventEmitter<void>();
  @Output() restarting = new EventEmitter<void>();
  @Output() resending = new EventEmitter<void>();
  @Output() turnOff = new EventEmitter<void>();
  @Output() turnOn = new EventEmitter<void>();
  @Output() starting = new EventEmitter<void>();
  @Output() stopping = new EventEmitter<void>();

  private readonly _items: RowMenuItem[] = [
    {
      id: 'edit',
      label: 'Редактировать',
      command: () => {
        this.editing.emit();
      },
    },
    {
      id: 'copy',
      label: 'Дублировать',
      command: () => {
        this.copying.emit();
      },
    },
    {
      id: 'delete',
      label: 'Удалить',
      command: () => {
        this.deleting.emit();
      },
    },
    {
      separator: true,
    },
    {
      id: 'turnOff',
      label: 'Отключить',
      command: () => {
        this.turnOff.emit();
      },
    },
    {
      id: 'turnOn',
      label: 'Включить',
      command: () => {
        this.turnOn.emit();
      },
    },
    {
      id: 'start',
      label: 'Запустить',
      command: () => {
        this.starting.emit();
      },
    },
    {
      id: 'stop',
      label: 'Остановить',
      command: () => {
        this.stopping.emit();
      },
    },
    {
      separator: true,
    },
    {
      id: 'restart',
      label: 'Перезапустить',
      command: () => {
        this.restarting.emit();
      },
    },
    {
      id: 'resend',
      label: 'Перепослать',
      command: () => {
        this.resending.emit();
      },
    },
  ];

  private readonly defaultOptions: RowMenuOptions = {
    visible: false,
    buttons: {
      copy: true,
      edit: true,
      delete: true,
      restart: false,
      turnOff: false,
      turnOn: false,
      start: false,
      stop: false,
    },
  };

  get items() {
    return this._items.filter(item => item.id && this.options?.buttons?.[item.id]);
  }

  constructor() {
    this.options = this.defaultOptions;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      if (this.options && !this.options.buttons) {
        this.options.buttons = this.defaultOptions.buttons;
      }
    }
  }
}
